

function isMobileDevice() {
  // Some iPadOS versions report platform as 'MacIntel' but have touch support.
  // Treat those as mobile as well so iPad/iPad Pro behave consistently.
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return true;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Detect iPad / iPadOS (covers iPad Pro which on newer iPadOS reports as MacIntel)
function isIpadPro() {
  // iPad in older UA strings
  if (/iPad/.test(navigator.userAgent)) return true;
  // iPadOS 13+ reports as MacIntel but has touch points > 1
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) return true;
  return false;
}

// Parse frame query param (supports frame, frame3, frame4...) to jump to a specific slide when landing from a link
const frameSearchParams = new URLSearchParams(window.location.search);
function getInitialSlideFromFrameParam() {
  // 1) Explicit ?frame=5
  if (frameSearchParams.has('frame')) {
    const raw = (frameSearchParams.get('frame') || '').trim();
    const num = parseInt(raw === '' ? '3' : raw, 10);
    if (!Number.isNaN(num)) return Math.max(0, num - 1);
  }

  // 2) Shorthand keys like ?frame3 or ?frame5 (value optional)
  for (const [key, val] of frameSearchParams.entries()) {
    const match = key.match(/^frame(\d+)$/i);
    if (!match) continue;
    const fallbackNum = parseInt(match[1], 10); // number from the key itself
    // If value is empty, use the number from the key; else parse value
    const parsed = val && val.trim() !== '' ? parseInt(val, 10) : fallbackNum;
    if (Number.isNaN(parsed)) continue;
    return Math.max(0, parsed - 1);
  }

  return null;
}

function checkRotateScreen() {
  // Requirement:
  // - On PC: do nothing (keep current behavior of the page)
  // - On Mobile: show .layer-rotate only when device is in landscape
  // We'll use a simple width/height check to determine orientation.
  if (!isMobileDevice()) {
    // On desktop/large devices we don't show the rotate overlay
    $('.layer-rotate').hide();
    return;
  }

  // On mobile, show only when landscape
  const isLandscape = window.matchMedia && window.matchMedia('(orientation: landscape)').matches
    ? true
    : window.innerWidth > window.innerHeight;

  if (isLandscape) {
    // Don't show the rotate overlay on iPad Pro / iPadOS devices
    if (!isIpadPro()) {
      $('.layer-rotate').show();
    } else {
      $('.layer-rotate').hide();
    }
  } else {
    $('.layer-rotate').hide();
  }
}
$(function () {
  checkRotateScreen();

  // Debounced resize/orientation handler to avoid thrash on rapid changes
  let resizeTimer = null;
  function debouncedCheck() {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      checkRotateScreen();
      resizeTimer = null;
    }, 120);
  }

  // Listen for both resize and orientationchange to cover browsers
  window.addEventListener('resize', debouncedCheck, { passive: true });
  window.addEventListener('orientationchange', debouncedCheck, { passive: true });

  // Special: on iPad Pro (iPad / iPadOS) when user rotates the device, reload after 200ms
  // This handles cases where the layout or orientation-specific resources need a fresh load.
  if (isIpadPro()) {
    let lastOrientation = (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) ? 'portrait' : (window.matchMedia && window.matchMedia('(orientation: landscape)').matches) ? 'landscape' : (window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
    let ipadReloadTimer = null;
    function handleIpadOrientationChange() {
      const current = (window.matchMedia && window.matchMedia('(orientation: portrait)').matches) ? 'portrait' : (window.matchMedia && window.matchMedia('(orientation: landscape)').matches) ? 'landscape' : (window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
      if (current === lastOrientation) return; // no change
      lastOrientation = current;
      if (ipadReloadTimer) clearTimeout(ipadReloadTimer);
      ipadReloadTimer = setTimeout(() => {
        // Use location.reload() to refresh the page state
        location.reload();
      }, 200);
    }
    window.addEventListener('orientationchange', handleIpadOrientationChange, { passive: true });
    // Also listen to resize as some browsers emit resize instead
    window.addEventListener('resize', handleIpadOrientationChange, { passive: true });
  }
});

// ===== Swiper setup =====
let swiper;

function initMainSwiper(retry = 0) {
  if ($('#MS__wrapper.iframe').length > 0) return;
  // Prevent duplicate initialization
  if (swiper) return;
  if (typeof window.Swiper === 'undefined') {
    if (retry < 20) { // thử lại tối đa 20 lần (2s)
      setTimeout(function () { initMainSwiper(retry + 1); }, 100);
    } else {
      console.error('Swiper CDN not loaded after waiting.');
    }
    return;
  }
  const requestedInitial = getInitialSlideFromFrameParam();
  const slideEls = document.querySelectorAll('.main-swiper .swiper-slide');
  const cappedInitial = (typeof requestedInitial === 'number' && slideEls.length > 0)
    ? Math.min(requestedInitial, slideEls.length - 1)
    : requestedInitial;

  swiper = new Swiper('.main-swiper', {

    direction: "vertical",
    slidesPerView: 1,
    // autoHeight: true,
    effect: 'fade',
    speed: 200,
    preloadImages: false,
    fadeEffect: {
      crossFade: true,
    },

    //   // Desktop: vẫn dùng wheel để đổi slide
    // mousewheel: {
    //   forceToAxis: true,       // chỉ ăn theo trục ngang/dọc đúng ý
    //   sensitivity: 0.4,        // giảm nhạy (thấp hơn = khó nhảy nhiều)
    //   thresholdDelta: 40,      // bỏ qua cuộn nhỏ lặt vặt
    //   thresholdTime: 300,      // gộp loạt sự kiện trong 300ms thành 1 lần
    //   releaseOnEdges: true,    // thả cho trang cuộn khi ở mép
    // },
    // Mobile: ta tự xử lý touch để ưu tiên scroll trong frame
    allowTouchMove: false,

    lazy: {
      loadPrevNext: false,
      loadOnTransitionStart: false,
    },

    initialSlide: (typeof cappedInitial === 'number') ? cappedInitial : 0,

    on: {
      // Giữ chỉ 1 listener slideChange tại đây (sẽ được override thêm bên dưới sau init nếu cần)
      slideChange() {
        // Kiểm tra slide đang hiển thị hiện tại
        const activeIdx = this.activeIndex;
        const activeSlideEl = this.slides && this.slides[activeIdx];
        const elVideo = $(activeSlideEl).find('.swiper-loadVideo');
        if (elVideo.length > 0) {
          if (elVideo.length === 0) return;

          elVideo.each(function (index, element) {
            const $this = $(this);

            // Nếu đã có thẻ <video> bên trong thì bỏ qua
            if ($this.find('video').length > 0) return;

            const videoSrc = $this.data('video');
            $this.append(`
              <video width="100%" height="auto" playsinline muted autoplay loop loading="lazy" style="position: absolute; top: 0; left: 0;">
                <source src="${videoSrc}">
              </video>
            `);
          });
        }
        if (this.isEnd) {
          $('#nth-ld-25-ld-footer').addClass('active');
        } else {
          $('#nth-ld-25-ld-footer').removeClass('active');
        }
      },
      slideChangeTransitionStart() {
        const spd = (this && this.params && typeof this.params.speed === 'number') ? this.params.speed : 200;
        const el = document.querySelector('.main-swiper');
        if (el) {
          el.style.transition = `transform ${spd}ms ease`;
          el.style.willChange = 'transform';
          // schedule transform to ensure transition kicks in smoothly
          requestAnimationFrame(() => { el.style.transform = 'scale(1.02)'; });
        }
        $('.swiper-main').removeClass('swiper-main');
      },
      slideChangeTransitionEnd() {
        const el = document.querySelector('.main-swiper');
        if (el) {
          el.style.transform = 'scale(1)';
        }
        // swiper.mousewheel && swiper.mousewheel.disable();
      }
    }
  });
  // Mark element to indicate initialized (alternative guard if global replaced)
  const containerEl = document.querySelector('.main-swiper');
  if (containerEl) {
    containerEl.dataset.swiperInitialized = '1';
    const spd = (swiper && swiper.params && typeof swiper.params.speed === 'number') ? swiper.params.speed : 200;
    containerEl.style.transition = `transform ${spd}ms ease`;
    containerEl.style.willChange = 'transform';
  }
}

// Gọi hàm khởi tạo Swiper
initMainSwiper();

window.addEventListener("load", function () {
  if ($('#MS__wrapper.iframe').length > 0) return;;

  // Only attempt init again if not already initialized (in case load fires after inline call)
  initMainSwiper();
  // ===== Helpers =====
  const EDGE_EPS = 2;                // dung sai mép
  const TOUCH_THRESHOLD = 70;        // cần kéo tối thiểu (px) để được xem là "ý định chuyển slide"
  const TRANSITION_LOCK = 40;        // buffer sau transitionEnd để tránh đúp

  function getScrollableAncestor(el) {
    while (el && el !== document.body && el !== document.documentElement) {
      const st = getComputedStyle(el);
      if ((st.overflowY === 'auto' || st.overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
        return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  function atTop(el) {
    return !el || el.scrollTop <= EDGE_EPS;
  }
  function atBottom(el) {
    if (!el) return true;
    return el.scrollTop + el.clientHeight >= el.scrollHeight - EDGE_EPS;
  }

  // Khóa trong lúc Swiper đang transition (chống nhảy nhiều)
  let isSliding = false;
  swiper.on('transitionStart', () => { isSliding = true; });
  swiper.on('transitionEnd', () => { setTimeout(() => isSliding = false, TRANSITION_LOCK); });

  // ===== TOUCH: chỉ xử lý ở touchend =====
  const rootEl = document.querySelector('.main-swiper');
  if (!rootEl) return; // Defensive: no root swiper container
  let touchStartY = 0;
  let activeScrollable = null;

  rootEl.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1 || isSliding) return;
    touchStartY = e.touches[0].clientY;
    activeScrollable = getScrollableAncestor(e.target);
    // Không preventDefault -> cho cuộn tự nhiên trong suốt touchmove
  }, { passive: true });

  rootEl.addEventListener('touchend', (e) => {
    if (isSliding) return;

    // Lấy tọa độ cuối
    const touch = e.changedTouches && e.changedTouches[0];
    if (!touch) return;

    const touchEndY = touch.clientY;
    const deltaY = touchStartY - touchEndY; // >0: kéo lên (muốn cuộn xuống)

    // Nếu kéo không đủ ngưỡng -> coi như chỉ scroll bình thường
    if (Math.abs(deltaY) < TOUCH_THRESHOLD) return;

    // Điều kiện chuyển slide:
    // - Hướng xuống (deltaY>0) & đang ở đáy vùng cuộn -> next
    // - Hướng lên   (deltaY<0) & đang ở đỉnh vùng cuộn -> prev
    // Nếu KHÔNG có vùng cuộn (frame ngắn) thì coi như đang ở mép cả hai phía.
    if (deltaY > 0) {
      if (atBottom(activeScrollable)) {
        console.log('[touch] next');
        swiper.slideNext();
      }
    } else {
      if (atTop(activeScrollable)) {
        console.log('[touch] prev');
        swiper.slidePrev();
      }
    }

    // reset
    activeScrollable = null;
  }, { passive: true });


  // ===== Auto Slide Change (one-off fallback to move user forward) =====
  // let hasUserOrAutoNavigated = false;
  // swiper.on('slideChange', () => { hasUserOrAutoNavigated = true; });
  // setTimeout(() => {
  //   if (!hasUserOrAutoNavigated && swiper && swiper.slides && swiper.slides[1]) {
  //     swiper.slideTo(1);
  //   }
  // }, 10000);

  // Custom autoplay for slide index near the end
  let facesAutoplayTimeout;
  let isUserInteracting = false; // Flag to track user interaction

  function clearFacesAutoplay() {
    if (!facesAutoplayTimeout) return;
    clearTimeout(facesAutoplayTimeout);
    facesAutoplayTimeout = null;
  }

  function scheduleFacesAutoplay() {
    clearFacesAutoplay();
    const facesSwiper = document.querySelector('.swiper-faces')?.swiper;
    if (!facesSwiper || isUserInteracting) return;
    if (!facesSwiper.slides || facesSwiper.slides.length <= 1) return;
    facesAutoplayTimeout = setTimeout(() => {
      // Defensive re-checks
      if (document.hidden) { clearFacesAutoplay(); return; }
      if (facesSwiper && !isUserInteracting) {
        facesSwiper.slideNext();
      }
      scheduleFacesAutoplay();
    }, 3000);
  }

  function maybeStartFacesAutoplay() {
    // Only start if on the proper slide and tab visible
    if (document.hidden) return;
    scheduleFacesAutoplay();
  }

  // Detect user interaction
  swiper.on('touchStart', () => {
    isUserInteracting = true;
    clearFacesAutoplay(); // Clear autoplay immediately on interaction
  });

  swiper.on('touchEnd', () => {
    isUserInteracting = false;
    maybeStartFacesAutoplay(); // Restart autoplay after interaction ends
  });

  swiper.on('slideChange', () => {
    const facesThumbSlides = document.querySelectorAll('#nth-ld-25-ld-faces .content .swiper-faces-thumb .swiper-slide');
    const isFacesSlide = swiper.activeIndex === swiper.slides.length - 2;
    facesThumbSlides.forEach(slide => {
      slide.style.pointerEvents = isFacesSlide ? 'auto' : 'none';
    });
    if (isFacesSlide) {
      maybeStartFacesAutoplay();
    } else {
      clearFacesAutoplay();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearFacesAutoplay();
    } else if (swiper && swiper.activeIndex === swiper.slides.length - 2) {
      maybeStartFacesAutoplay();
    }
  });

  window.addEventListener('beforeunload', () => {
    clearFacesAutoplay();
  });
  window.addEventListener('pagehide', () => { // iOS Safari background gesture
    clearFacesAutoplay();
  });

  // ===== Nested Swiper wheel guard (Desktop only) =====
  if (!isMobileDevice()) {
    // ===== Main wheel logger (Desktop) =====
    // Log direction once per gesture; do not change slides here.
    (function setupMainWheelLogger() {
      // Nghe wheel ở document, KHÔNG chỉ trong .main-swiper:
      // nav trái (float_left), thanh nav trên và dải trống dưới footer nằm ngoài .main-swiper
      // -> lăn chuột ở mấy vùng đó trước đây không đổi slide (cảm giác "trang chủ không xuống được frame sau").
      const root = document;
      if (root._mainWheelLoggerAttached) return;
      root._mainWheelLoggerAttached = true;

      const LINE_HEIGHT = 16; // for deltaMode===1
      const MIN_ABS = 30;     // ignore tiny/noise
      const LOCK_MS = 600;    // one log per gesture
      let lockUntil = 0;

      function normalizeDelta(e) {
        let dx = e.deltaX, dy = e.deltaY;
        if (e.deltaMode === 1) { dx *= LINE_HEIGHT; dy *= LINE_HEIGHT; }
        else if (e.deltaMode === 2) { dx *= window.innerWidth; dy *= window.innerHeight; }
        return { dx, dy };
      }

      root.addEventListener('wheel', (e) => {
        if (e.defaultPrevented) return;
        // Đang mở popup / iframe overlay thì đừng cuộn slide phía sau
        // (popup lúc đóng là display:none nên không bao giờ là target)
        if (e.target && e.target.closest && e.target.closest('.MS__popup, .container-iframe')) return;
        const { dx, dy } = normalizeDelta(e);
        if (Math.abs(dy) < Math.abs(dx)) return; // vertical only
        if (Math.abs(dy) < MIN_ABS) return;

        const now = Date.now();
        if (now < lockUntil || isSliding) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        // Respect inner scrollable content first
        const scrollable = getScrollableAncestor(e.target);
        if (dy > 0) {
          if (scrollable && !atBottom(scrollable)) return;
        } else {
          if (scrollable && !atTop(scrollable)) return;
        }

        const dir = dy > 0 ? 'next' : 'prev';
        console.log('[wheel]', dir);
        // Trigger exactly one slide per gesture
        if (swiper && !swiper.destroyed) {
          const spd = swiper.params && typeof swiper.params.speed === 'number' ? swiper.params.speed : 200;
          if (dir === 'next') {
            swiper.slideNext(spd, true);
          } else {
            swiper.slidePrev(spd, true);
          }
        }
        lockUntil = now + LOCK_MS;
        // prevent default to avoid other handlers/pages reacting
        e.preventDefault();
        e.stopPropagation();
      }, { passive: false });
    })();
    // Mục tiêu: Khi có Swiper lồng bên trong slide (ví dụ faces slider ngang), dùng wheel sẽ chạy hết các slide bên trong
    // trước khi cho Swiper dọc bên ngoài chuyển slide.
    function attachInnerWheelGuard(innerEl) {
      if (!innerEl || innerEl._innerWheelGuardAttached) return;
      const innerSwiper = innerEl.swiper;
      if (!innerSwiper) return; // chưa init
      innerEl._innerWheelGuardAttached = true;
      let innerLockUntil = 0;
      let innerIsSliding = false;
      const WHEEL_LOCK = 600; // ms: một cử chỉ = 1 lần
      const LINE_HEIGHT = 16;
      const MIN_ABS = 30;

      // Smooth scale transitions for inner container
      const spdInner = (innerSwiper.params && typeof innerSwiper.params.speed === 'number') ? innerSwiper.params.speed : 200;
      innerEl.style.transition = `transform ${spdInner}ms ease`;
      innerEl.style.willChange = 'transform';
      innerSwiper.on('transitionStart', () => { innerIsSliding = true; });
      innerSwiper.on('transitionEnd', () => { innerIsSliding = false; });
      innerSwiper.on('slideChangeTransitionStart', () => {
        requestAnimationFrame(() => { innerEl.style.transform = 'scale(1.02)'; });
      });
      innerSwiper.on('slideChangeTransitionEnd', () => {
        innerEl.style.transform = 'scale(1)';
      });

      function normalizeDelta(e) {
        let dx = e.deltaX, dy = e.deltaY;
        if (e.deltaMode === 1) { dx *= LINE_HEIGHT; dy *= LINE_HEIGHT; }
        else if (e.deltaMode === 2) { dx *= window.innerWidth; dy *= window.innerHeight; }
        return { dx, dy };
      }

      innerEl.addEventListener('wheel', function (e) {
        if (!innerSwiper || innerSwiper.destroyed) return;
        const { dx, dy } = normalizeDelta(e);
        if (Math.abs(dy) < Math.abs(dx)) return; // chỉ xử lý cử chỉ theo trục dọc
        if (Math.abs(dy) < MIN_ABS) return;      // bỏ nhiễu

        const now = Date.now();
        if (now < innerLockUntil || innerIsSliding) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        // Ở trong inner, ưu tiên chạy hết inner trước khi thả cho outer
        if (dy > 0 && !innerSwiper.isEnd) { // xuống -> next
          const spd = (innerSwiper.params && typeof innerSwiper.params.speed === 'number') ? innerSwiper.params.speed : 200;
          innerSwiper.slideNext(spd, true);
          innerLockUntil = now + WHEEL_LOCK;
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if (dy < 0 && !innerSwiper.isBeginning) { // lên -> prev
          const spd = (innerSwiper.params && typeof innerSwiper.params.speed === 'number') ? innerSwiper.params.speed : 200;
          innerSwiper.slidePrev(spd, true);
          innerLockUntil = now + WHEEL_LOCK;
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        // ở mép -> thả cho outer
      }, { passive: false });
    }
    function scanAndAttachInnerSwipers() {
      document.querySelectorAll('.main-swiper .swiper').forEach(el => {
        if (el.classList.contains('main-swiper')) return;
        // #tournament: slider con (tab giải đấu, trang Tổng quan/Thể lệ/...) chỉ điều hướng bằng tab/nút.
        // Nếu để guard cướp wheel thì phải lăn hết 5 trang con mới qua được frame sau.
        if (el.closest('#tournament')) return;
        attachInnerWheelGuard(el);
      });
    }
    // Lần đầu sau load
    scanAndAttachInnerSwipers();
    // Theo dõi phát sinh động
    const mo = new MutationObserver(() => scanAndAttachInnerSwipers());
    const mainSwiperEl = document.querySelector('.main-swiper');
    if (mainSwiperEl) {
      mo.observe(mainSwiperEl, { childList: true, subtree: true });
    }
  }

});


// ===== PostMessage =====

window.addEventListener('message', function (e) {
  if (e.data && e.data.type === 'closePopup') {
    $('.container-iframe').removeClass('active');
  }
});

window.addEventListener("load", function () {
  $('.MS__popup-close').on('click', function () {

    sendMessageToParent({
      type: 'closePopup'
    });
  });
});

// Đảm bảo iframe con gửi đúng thông điệp ra cha
function sendMessageToParent(message) {
  if (window.parent) {
    window.parent.postMessage(message, '*'); // '*' có thể thay bằng nguồn cụ thể nếu cần
  };
}